import type { FaireProductEntity } from "../../entity_types/product";

export const p_bep4xu4nzx: FaireProductEntity = {
  token: "p_bep4xu4nzx",
  type: "product",
  name: "DUCK with GOOSE & SWEET POTATO",
  brandToken: "b_urfqrqmy52",
  brandName: "Celtic Connection Holistic Pet Food",
  imageUrl: "https://cdn.faire.com/fastly/c058f84e5b50bd0658f4d8f1f593c9239e9c1344b37a672b61b350177efefb11.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/382d733cb8a7548d281170a314b24a21747af788ca6a0fcdc76f88226a4f0f15.jpeg"
  ],
  priceDollars: 16.51,
  description: "Our Duck with Goose & Sweet Potato recipe is perfect for when your dog wants to 'go a little wild!' With delicious ethically-farmed duck and goose as the main source of protein and plenty of fruits, vegetables, and botanical herbs, this grain-free recipes uses only natural ingredients, 'fit for human consumption' to keep furry family members healthy. And the therapeutic levels of the synergistic blend of glucosamine, chondroitin, and MSM keep joints comfortable for a long, happy, active life.\n\nRecipe:\n• Holistic formulation to support detox organs\n• 70% animal ingredients \n• 30% fruits, vegetables, and functional herbs\n• 0% grain & gluten\n• Therapeutic amounts of joint support\n• Hypoallergenic\n• Free from grain, gluten, white potato, rice, GMO's and fish\n• Suitable for all life stages (from puppy to senior)\n\nProtein Sources:\n• Duck\n• Goose\n\nFunctional Ingredients:\n• Artichoke leaf\n• Cinnamon\n• Cranberries\n• Pumpkin\n• Yucca Schidigera\n• Schizochytrium",
  tags: [],
  msrpDollars: 33.02,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T18:46:36.713Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
